import { render } from "./CustomRadio.vue?vue&type=template&id=08dc12ad&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"

import "./CustomRadio.vue?vue&type=style&index=0&id=08dc12ad&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dc12ad"]])

export default __exports__